module.exports = __webpack_public_path__ + "static/img/arrow-down.d5061e37.svg";